export const DEPLOYMENT_MESSAGE_MAX_LENGTH = 240;
/** Full deployment diagnostics stay in the durable target receipt. */
export function deploymentMessageSummary(message) {
    if (message.length <= DEPLOYMENT_MESSAGE_MAX_LENGTH)
        return message;
    const suffix = "… [full details in target receipt]";
    let prefix = message.slice(0, DEPLOYMENT_MESSAGE_MAX_LENGTH - suffix.length);
    if (/[\uD800-\uDBFF]$/u.test(prefix))
        prefix = prefix.slice(0, -1);
    return prefix + suffix;
}
